export const APP_DETAILS = {
  TITLE: "Hays Trinity Groundwater Conservation District Dashboard",
  SHORT_TITLE: "Hays Trinity GCD Dashboard",
  NAME: "Hays Trinity Groundwater Conservation District",
  SHORT_NAME: "Hays Trinity GDC",
  ABBREVIATED_NAME: "HTGCD",
  ICONS: {
    LOGO_FULL_LONG_WHITE:
      "/static/img/branding/haystrinity-logo-full-long-white.png",
    LOGO_FULL_WHITE: "/static/img/branding/haystrinity-logo-full-white.png",
    LOGO_FULL_COLOR: "/static/img/branding/haystrinity-logo-full-color.png",
    LOGO_FULL_COLOR_WHITE_BG:
      "/static/img/branding/haystrinity-logo-full-color-white-bg.png",
    LOGO_SIMPLE_WHITE: "/static/img/branding/haystrinity-logo.png",
    LOGO_SIMPLE_COLOR: "/static/img/branding/haystrinity-logo-simple-color.png",
  },
  URL: "https://haysgroundwater.com/",
};

export const ROUTES = {
  LANDING: "/",
  MAP: "/tools/map",
  USERS_MANAGEMENT: "/administration/users-management",
  METERS_MANAGEMENT: "/administration/meters-management",
  PERMITS_MANAGEMENT: "/administration/permits-management",
  ALLOCATION_PROFILES_MANAGEMENT:
    "/administration/allocation-profiles-management",
  WELLS_MANAGEMENT: "/administration/wells-management",
  WELL_REGISTRATIONS_MANAGEMENT:
    "/administration/well-registrations-management",
  CONTACTS_MANAGEMENT: "/administration/contacts-management",
  WATER_SERVICE_CONNECTIONS_MANAGEMENT:
    "/administration/water-service-connections-management",
  PUBLIC_WATER_SYSTEM_CONTACTS_MANAGEMENT:
    "/administration/public-water-system-contacts-management",
  DROUGHT_STAGE_UPDATE: "/administration/drought-stage-management",
  DROUGHT_PRODUCTION_CUTBACK: "/administration/drought-production-cutback",
  PUBLIC_FORMS: "/public-forms",
  PENDING_WELL_REGISTRATIONS_MANAGEMENT: "/forms/pending-well-registrations",
  PENDING_WELL_REGISTRATION: "/forms/pending-well-registrations/:id?",
  NEW_WELL_REGISTRATION: "/public-forms/new-well-registrations",
  NEW_WATER_SERVICE_CONNECTION: "/public-forms/new-water-service-connection",
  PENDING_WATER_SERVICE_CONNECTIONS_MANAGEMENT:
    "/forms/pending-water-service-connections",
  PENDING_WATER_SERVICE_CONNECTION:
    "/forms/pending-water-service-connections/:id?",
  EXISTING_WELL_REGISTRATION: "/public-forms/existing-well-registration",
  PUMPAGE_REPORT: "/forms/pumpage-report",
  WATER_LEVEL_REPORT: "/forms/water-level-records",
  WATER_QUALITY: "/administration/water-quality",
  USER_LOGOUT: "/auth/logout",
  SPLASH: "/login",
};

export const APP_THEME = {
  LAYOUT: {
    SIDEBAR_WIDTH: 258,
  },
  DATE_FORMATS: {
    LONG: "MMMM do yyyy, h:mma",
    SHORT: "MM/dd/yyyy",
  },
  TYPOGRAPHY: {
    HEADER_FONT: "Arial, sans-serif",
  },
};

export const MUI_THEME = {
  COLORS: {
    PRIMARY: "#2F3033",
    SECONDARY: "#5995CF",
    DARK_SOURCE: "#1D2228",
    GREY_SOURCE: "#E1E2E2",
  },
};

export const REACT_QUERY_CONFIG = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
};

export const CRUD_LOOKUP_TABLES = [];
